/* eslint-disable @typescript-eslint/no-unused-vars */
import { UPDATE_PORTAL_FORM_API_URL } from 'api/apiConstants';
import { SelectedGateways } from 'containers/dashboard/Forms/FormListingType';
import { isApiError } from 'utils/apiFunctions';
import axiosInstance from 'utils/axios';
import { toFloat } from 'utils/formatNumber';
import snackbar from 'utils/SnackbarUtils';

export const getSelectedGateways = (selectedGateways: SelectedGateways[]) => {
  const selected: string[] = [];
  selectedGateways.map(gateway =>
    gateway.is_selected ? selected.push(gateway._id) : null
  );

  return selected;
};

export const updateForm = async (
  state: any,
  formId: string,
  portalId: string
) => {
  try {
    const response = await axiosInstance.post(
      `${UPDATE_PORTAL_FORM_API_URL}/${formId}`,
      {
        name: state.name,
        form_type: 'normal',
        portal_id: Number(portalId),
        hubspot_form_id: state.selectedHubspotFormId,
        mode: state.mode ? 'test' : 'live',
        amount:
          state.allowDonation && state.allowCustomAmount
            ? toFloat(state.customAmount)
            : toFloat(state.amount),
        currency: state.selectedGateways.find(
          (method: any) => method.is_selected
        )?.settings.payment_currency,
        payment_type: state.paymentType,
        allow_discount_code: state.allowDiscountCode,
        donation_form_settings: {
          allow_donation: state.allowDonation,
          donation_form_title: state.allowDonation ? state.title : '',
          donation_form_description: state.allowDonation
            ? state.description
            : '',
          donation_form_image: state.allowDonation ? state.logo : '',
          allow_custom_amount: state.allowDonation
            ? state.allowCustomAmount
            : false,
          amount:
            state.allowDonation && state.allowCustomAmount
              ? state.customAmount
              : 0,
          suggested_amount:
            state.allowDonation && state.allowCustomAmount
              ? state.suggestedAmount
              : [],
          show_donation_memory: state.allowDonation
            ? state.showDonationMemory
            : false,
          donation_memory_label:
            state.allowDonation && state.showDonationMemory
              ? state.donationMemoryLabel
              : '',

          donate_button_text: state.donateButtonText,
          transaction_cost_setting: {
            allow_transaction_cost: state.allowTransactionCost,
            transaction_cost_label: state.allowTransactionCost
              ? state.transactionCostLabel
              : '',
            transaction_cost_type: state.allowTransactionCost
              ? state.transactionCostType
              : 'fixed',

            transaction_cost_fixed_amount:
              state.allowTransactionCost &&
              state.transactionCostType === 'fixed'
                ? state.transactionAmount
                : 0,
            transaction_cost_variable_base_amount:
              state.allowTransactionCost &&
              state.transactionCostType === 'variable'
                ? state.transactionCostVariableBaseAmount
                : 0,
            transaction_cost_variable_unit_amount:
              state.allowTransactionCost &&
              state.transactionCostType === 'variable'
                ? state.transactionUnitAmount
                : 0,
          },
        },
        after_submission_settings: {
          back_button_text: state.backButtonText,
          allow_redirection: state.allowRedirection,
          redirect_url: state.redirectUrl,
          thankyou_image: state.thankyouImage,
          thankyou_title: state.thankyouTitle,
          thankyou_subtitle: state.thankyouSubtitle,
          thankyou_description: state.thankyouDescription,
          back_button_link: state.backButtonLink,
        },
        allow_redirection: state.allowRedirection,
        redirect_url: state.redirectUrl,
        selected_gateways: getSelectedGateways(state.selectedGateways),
        theme_color: state.themeColor,
        payButton: state.payButton,
        pay_button_text: state.payButtonText,
      }
    );
  } catch (error) {
    if (isApiError(error)) {
      // @ts-ignore
      snackbar(error.message, { variant: 'error' });
    }
  }
};
